/*
 * HomePage Messages
 *
 * This contains all the text for the HomePage component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  aboutDescription: {
    defaultMessage: `The SportKompas I LIKE is a product from SportaMundi based on the research of Ghent University and NYSI Signapore.`,
    id: 'app.about.description'
  },
  aboutCopyright: {
    defaultMessage: 'All rights reserved.',
    id: 'app.about.copyright'
  },
  aboutMore: {
    defaultMessage: `More info on <a href="http://www.sportkompas.be/en" target="_blank">sportkompas.be/en</a>.`,
    id: 'app.about.more'
  },
  aboutButton: {
    defaultMessage: 'Restart',
    id: 'app.about.button'
  }
});



// WEBPACK FOOTER //
// ./src/containers/about/messages.js